import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import LoadingIndicator from "components/LoadingIndicator";
import { debounce } from "lodash";

const Submit = ({ value, classes, ...inputProps }) => {
  const [clicked, setClicked] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const isSubmitSuccessful = inputProps.formContext.isSubmitSuccessful;
  const isSubmitting = inputProps.formContext.isSubmitting;
  const isValid = inputProps.formContext.isValid;
  const handleClick = () => {
    setClicked(true);
    hideLoader();
  };

  useEffect(() => {
    if (isSubmitting) {
      setShowLoader(true);
    }
    if (!isValid) {
      setShowLoader(false);
    }
  }, [isValid, isSubmitting]);

  useEffect(() => {
    if (isSubmitSuccessful) {
      setClicked(false);
      setShowLoader(false);
    }
  }, [isSubmitSuccessful]);

  const hideLoader = useRef(debounce(() => {
    setShowLoader(false);
  }, 2000)).current;

  useEffect(() => () => {
    hideLoader.cancel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hasDisabledButtonClass = inputProps.disabled || (!isValid && clicked);

  return (
    <button
      type="submit"
      value={value ?? "submit"}
      onClick={handleClick}
      disabled={inputProps.disabled || false}
      className={`submit ${classes ?? ""} ${hasDisabledButtonClass ? "disabled" : ""}`}
    >
      {showLoader ? (
        <span>
          {inputProps.loadingMessage ?? "submitting"}
          <LoadingIndicator className="button__loading-indicator" />
        </span>
      ) : (
        inputProps.children ?? value
      )}
    </button>
  );
};

Submit.propTypes = {
  value: PropTypes.string,
  classes: PropTypes.string,
};

export default Submit;
